import { createContext, useState, useContext, useEffect } from 'react';
import isEqual from 'lodash.isequal';

const DataContext = createContext(null);

const DataProvider = ({ children }) => {

    const [dataShipement, _setDataShipement] = useState({});
    const [initialDataShipement, _setInitialDataShipement] = useState({});

    const [dataServiceList, setDataServiceList] = useState([]);
    

    const [dataTier, setDataTier] = useState({});
    const [dataContact, setDataContact] = useState({});
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'fr');


    // Synchronous update with deep compare to avoid unnecessary updates
    const setDataShipement = (newData) => {
        _setDataShipement(prev => {
            const nextData = typeof newData === 'function' ? newData(prev) : newData;
            if (isEqual(prev, nextData)) return prev;
            // If nextData is not an object, just return it (for full replace)
            if (typeof nextData !== 'object' || nextData === null) return nextData;
            // If prev is not an object, just return nextData
            if (typeof prev !== 'object' || prev === null) return nextData;
            // Merge for partial updates, otherwise replace
            // If nextData has all keys of prev, treat as replace
            // Otherwise, merge
            // For safety, just replace
            return nextData;
        });
    };

    const setInitialDataShipement = (newData) => {
        _setInitialDataShipement(prev => {
            const nextData = typeof newData === 'function' ? newData(prev) : newData;
            if (isEqual(prev, nextData)) return prev;
            return nextData;
        });
    };

    const updateDataShipement = (newData) => {
        setDataShipement(prev => ({
            ...prev,
            ...(typeof newData === 'function' ? newData(prev) : newData)
        }));
    };


    const updateDataTier = (newData) => {
        setDataTier((prevData) => ({
            ...prevData,
            ...newData,
        }));
    }

    const updateDataContact = (newData) => {
        setDataContact((prevData) => ({
            ...prevData,
            ...newData,
        }));
    };

    const updateLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        localStorage.setItem('language', newLanguage);
    }



    const value = {
        dataShipement, updateDataShipement, setDataShipement,
        initialDataShipement, setInitialDataShipement,
        dataServiceList, setDataServiceList,
        dataTier, updateDataTier,
        dataContact, updateDataContact,
        language, updateLanguage,
    };

    useEffect(() => {
        const storedLanguage = localStorage.getItem('language');
        if (storedLanguage) {
            setLanguage(storedLanguage);
        }
    }, []);

    return (
        <DataContext.Provider value={value}>
            {children}
        </DataContext.Provider>
    );
};



const useData = () => {
    return useContext(DataContext);
};

export { useData, DataProvider };